import styled from 'styled-components'
import { mediaqueries } from '../../utils/mediaqueries'
import { GreatPrimer, Brevier } from '~/components/Typography'

export const Container = styled.div``

export const Header = styled.div`
  display: none;

  @media ${mediaqueries.md} {
    display: flex;
  }
`

export const HeaderItem = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 20%;
  text-transform: uppercase;

  &:first-of-type {
    flex: 0 0 40%;
    justify-content: flex-start;
  }

  ${({ theme: { toRem } }) => `
    padding: ${toRem(10)} 0 ${toRem(20)};
  `}
`
export const Items = styled.div`
  ${({ theme: { color } }) => `
    border-top: 1px solid ${color('core')};
    border-bottom: 1px solid ${color('core')};
  `}
`

export const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 16px;

  @media ${mediaqueries.md} {
    padding-top: 32px;
  }

  align-items: center;
  justify-content: flex-end;

  & > h3 {
    align-items: center;
    flex: 0 0 100%;
    display: flex;

    small {
      display: block;
      font-size: 70%;
    }

    span {
      text-align: right;
      flex: 1;
      @media ${mediaqueries.md} {
        flex: none;
        width: 250px;
      }
    }

    @media ${mediaqueries.md} {
      justify-content: flex-end;
      
    }
  }
`
export const Button = styled(GreatPrimer)`
  display: block;
  appearance: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600 !important;
  border: 0;
  border-radius: 6px;
  margin-top: 24px;
  font-size: 20px !important;
  height: 80px;
  background: #19AE5C !important;

  @media ${mediaqueries.max.md} {
    position: fixed;
    width: calc(100% - 20px);
    bottom: 30px;
    left: 10px;
    z-index: 1000;
  }

  @media ${mediaqueries.md} {
    width: auto;
  }

  ${({ theme: { color, toRem } }) => `
    background: ${color('core')};
    color: ${color('light')};
    padding: ${toRem(20)} ${toRem(35)};
  `}

  svg {
    fill: white;
    transform: rotate(-90deg);
    width: 22px;
    margin-bottom: 1px;
  }
`

export const FooterLabel = styled(Brevier)`
  text-transform: uppercase;
  font-weight: 100 !important;
`
